import { createApp } from 'vue'
import ZakuProductRequestsUploader from './zaku-product-requests-uploader.vue'
import i18nPlugin, { i18n, loadTranslations } from './i18n'

$.onmount('[data-vue=zaku-product-requests-uploader]', async function () {
  const props = JSON.parse(this.attributes['data-props'].value)
  const app = createApp(ZakuProductRequestsUploader, props)
  app.use(i18nPlugin)
  await loadTranslations(i18n)
  app.mount(this)
})
